import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  LinearProgress,
  Menu,
  MenuItem,
  IconButton
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Autocomplete } from "@mui/lab";
import ClientService from "../../services/ClientService";
import CircularProgress from "@mui/material/CircularProgress";

import UpdateIcon from "@mui/icons-material/Update";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import MyAutocomplete from "../../components/layout/MyAutocomplete.js";
import FlightService from "../../services/FlightService";

import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

const cssInJs = {
  header: {
    backgroundColor: "#422e52",
    color: "#fff",
  },
  footer: {
    backgroundColor: "#eee9f3",
    padding: "10px",
  },
  grayBlock: {
    background: "#fafafa",
    padding: "10px",
  },
  textInput: {
    marginRight: "20px",
    marginBottom: "15px",
  },
  formControl: {
    minWidth: 16,
    minHeight: 16,
    marginRight: "20px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
};
function JobSettings({ selectedFlightJob, showJobSettings, onSave, onRun }) {

  const [loading, setLoading] = React.useState(true);
  const [selectedOption, setSelectedOption] = React.useState([]);
  const [showAdditionalInputs, setShowAdditionalInputs] = React.useState(false);
  const [currentIcon, setCurrentIcon] = useState("UpdateIcon");
  const [clients, setClients] = React.useState([]);
  const [isEditing, setIsEditing] = React.useState(false);
  const [uploadDataForm, setUploadDataForm] = useState({
    startDate: "",
    endDate: "",
  });

  const [runTime, setRunTime] = useState("");
  const [interval, setInterval] = useState("");
  const [open_more, setOpenMore] = useState(false)
  const more_element = useRef()

  const handleIconClick = () => {
    setShowAdditionalInputs(!showAdditionalInputs);
    setCurrentIcon((prevIcon) =>
      prevIcon === "UpdateIcon" ? "EditRoundedIcon" : "UpdateIcon"
    );
  };

  const loadClients = async () => {
    try {
      setLoading(true);
      const _clients = await ClientService.searchClients(null, true);
      setClients(_clients);
    } catch (error) {
      console.error("Error loading clients", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadClients();
  }, []);

  const handleClientSelect = (event, value) => {
    setSelectedOption(value);
  };

  const [checked, setChecked] = React.useState(false);

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const handleClose = () => {
    showJobSettings(false);
  };

  const handleSave = () => {
    if (selectedOption) {
      const flightJob = {
        client_id: selectedOption.Id,
        startDate: uploadDataForm.startDate.format("YYYY-MM-DD"),
        endDate: uploadDataForm.endDate.format("YYYY-MM-DD"),
        time_of_day: runTime,
        interval: interval,
        job_type_id: 2,
      };

      onSave(flightJob);
    }
  };

  const handleDeleteFlightJob = async () => {
    if (selectedFlightJob) {
      console.log(selectedFlightJob, "selected flight job");
      const response = await FlightService.deleteFlightJob(selectedFlightJob.id)
      console.log(response, "delete flight job response")
      onDelete(selectedFlightJob.id);
    }
  }


  const handleRun = async () => {
    if (selectedFlightJob) {
      const jobData = {
        job_json: JSON.stringify({
          period: interval,
          isMonthToDate: true,
        }),
      };
      try {
        const jobLog = await FlightService.runFlightJob(
          selectedFlightJob.id,
          jobData
        );
        onRun(jobLog);
      } catch (error) {
        console.error("Error running flight job:", error);
      }
    } else {
      console.error("Cannot run job - selectedFlightJob is empty");
    }
  };

  const getAutocompleteValue = () => {
    if (
      selectedFlightJob &&
      selectedFlightJob.client &&
      selectedFlightJob.client.Name
    ) {
      return {
        Name: selectedFlightJob.client.Name,
        Id: selectedFlightJob.client.Id,
      };
    } else if (selectedOption && selectedOption.Name && selectedOption.Id) {
      return selectedOption;
    } else {
      return null;
    }
  };

  return (
    <Card>
      <CardHeader
        title={
          selectedFlightJob &&
            selectedFlightJob.id &&
            selectedFlightJob.client &&
            selectedFlightJob.client.Name &&
            selectedFlightJob.client.ClientCode
            ? `${selectedFlightJob.id} ${selectedFlightJob.client.Name} ${selectedFlightJob.client.ClientCode}`
            : "Edit Job"
        }
        sx={{
          ...cssInJs.header,
          "& .MuiTypography-root": {
            fontSize: "16px",
          },
        }}
      />
      <Box sx={cssInJs.grayBlock}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h7">Run Job Settings</Typography>
          <IconButton onClick={e => { setOpenMore(true) }} ref={more_element}>
            <MoreVertOutlinedIcon sx={{ color: 'black' }} />
          </IconButton>
        </div>
        <Menu
          open={open_more}
          anchorEl={more_element.current}
          onClose={e => { setOpenMore(false) }}
        >
          <MenuItem dense onClick={handleDeleteFlightJob}>Delete Job</MenuItem>
        </Menu>
      </Box>
      <CardContent>
        {showAdditionalInputs ? (
          <>
            <TextField
              id="standard-basic"
              label="Run period"
              variant="standard"
              fullWidth
              sx={cssInJs.textInput}
              onChange={(e) => setInterval(e.target.value)}
            />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Start date"
                value={uploadDataForm.startDate}
                inputFormat="MMM dd"
                mask=""
                onChange={(e) =>
                  setUploadDataForm({ ...uploadDataForm, startDate: moment(e) })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth={true}
                    variant="outlined"
                    size="small"
                    sx={cssInJs.textInput}
                  />
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="End date"
                value={uploadDataForm.endDate}
                inputFormat="MMM dd"
                mask=""
                onChange={(e) =>
                  setUploadDataForm({ ...uploadDataForm, endDate: moment(e) })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth={true}
                    variant="outlined"
                    size="small"
                    sx={cssInJs.textInput}
                  />
                )}
              />
            </LocalizationProvider>
          </>
        ) : (
          <>
            <Autocomplete
              openOnFocus
              size="small"
              options={clients.map((client) => ({
                ...client,
                key: client.Id,
              }))}
              getOptionLabel={(option) =>
                `${option.Name ?? ""} ${option.Id ?? ""}`
              }
              loadingText={<CircularProgress color="inherit" />}
              onOpen={loadClients}
              loading={loading}
              value={getAutocompleteValue()}
              onChange={handleClientSelect}
              isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
              renderInput={(params) => <TextField {...params} label="Client" />}
            />

            <TextField
              id="run-time"
              label="Run time"
              variant="standard"
              fullWidth
              sx={cssInJs.textInput}
              onChange={(e) => setRunTime(e.target.value)}
            />
            <TextField
              id="interval"
              label="Interval (10 min)"
              variant="standard"
              fullWidth
              sx={cssInJs.textInput}
              onChange={(e) => setInterval(e.target.value)}
            />
          </>
        )}
      </CardContent>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "between",
          ...cssInJs.footer,
        }}
      >
        {currentIcon === "UpdateIcon" ? (
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save Job
          </Button>
        ) : (
          selectedFlightJob && selectedFlightJob.client && selectedFlightJob.client.Name ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleRun}
              disabled={!selectedFlightJob}
            >
              Run Job
            </Button>
          ) : null
        )}

        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label="Is end of month"
          sx={{ marginLeft: 2 }}
        />

        {currentIcon === "UpdateIcon" ? (
          <UpdateIcon
            onClick={
              (() => setShowAdditionalInputs(!showAdditionalInputs),
                handleIconClick)
            }
            sx={{
              color: "white",
              backgroundColor: "#f97125",
              borderRadius: "50%",
              padding: "8px",
              width: "36px",
              height: "36px",
              boxShadow: "rgba(0,0,0,0.45) 0px 2px 7px 0px;",
              fontSize: "1.2rem",
              lineHeight: "16px",
              marginBottom: "-8px",
              textAlign: "center",
              position: "absolute",
              right: "15px",
              zIndex: "94",
            }}
          />
        ) : // Check if it's a new job creation, if yes, don't show the Run button
          !selectedFlightJob ? null : (
            <EditRoundedIcon
              onClick={handleIconClick}
              sx={{
                color: "white",
                backgroundColor: "#f97125",
                borderRadius: "50%",
                padding: "8px",
                width: "36px",
                height: "36px",
                boxShadow: "rgba(0,0,0,0.45) 0px 2px 7px 0px;",
                fontSize: "1.2rem",
                lineHeight: "16px",
                marginBottom: "-8px",
                textAlign: "center",
                position: "absolute",
                right: "15px",
                zIndex: "94",
              }}
            />
          )}
      </Box>
    </Card>
  );
}

export default JobSettings;
